import { GlobalStyles } from './GlobalStyles';
import { ThemeProvider } from './ThemeProvider';
import { PropagationProvider } from './PropagationProvider';
import { ToastProvider } from '../Toast/ToastContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const shouldRenderToastProvider = () => {
  // If inside an iframe and the iframe is not a Storybook iframe, don't render the ToastProvider
  if (window !== window.top) {
    try {
      const isStorybookIframe = window.parent.document.querySelector('iframe[data-is-storybook="true"]');
      return isStorybookIframe !== null;
    } catch (error) {
      // Default to false in case of security restrictions
      return false;
    }
  }

  // Default to rendering the ToastProvider when not in an iframe
  return true;
};
export const AppProvider = ({
  themeName = 'current',
  themeMode = 'light',
  applyGlobalStyles = true,
  continuePropagation = false,
  children,
  toast = {
    autoClose: true
  }
}) => {
  return /*#__PURE__*/_jsx(ThemeProvider, {
    themeName: themeName,
    themeMode: themeMode,
    children: /*#__PURE__*/_jsxs(PropagationProvider, {
      continuePropagation: continuePropagation,
      children: [applyGlobalStyles ? /*#__PURE__*/_jsx(GlobalStyles, {}) : null, shouldRenderToastProvider() ? /*#__PURE__*/_jsx(ToastProvider, Object.assign({}, toast, {
        children: children
      })) : children]
    })
  });
};